/* =====================================================================
   CUSTOM EMBROIDERED DECK MAT — BoatMat.com
   2026-09-29. Built on the exact HD DigiPrint™ Design Station framework
   (same UX, same steps) so the two products feel like one ordering system.
   ONE product: Custom Embroidered Deck Mat with AquaLoc® marine backing.
   Colors + sizes + variant ids are the LIVE, verified deck product data
   (custom-embroidered-boat-mat); logo digitizing is INCLUDED FREE on deck
   mats (boarding is the product that charges $150 — NOT this one).

   PRICE AUTHORITY: the Shopify variant id decides the price server-side.
   The amounts below are display-only and mirror the live variants.

   Colors: the four verified deck carpet colors (window.DECK_COLORS from the
   section), carried as their display names; each maps to the real Shopify
   fulfillment variant color server-side.

   MULTI-MAT ORDERS: Quantity multiplies the current configuration;
   ADD ADDITIONAL MAT banks the current configuration (its own size, color,
   artwork file, placement, quantity, notes) and starts a fresh one. ADD TO
   CART submits every configuration as its own real multipart form post to
   /cart/add (targeted at a hidden iframe, one after another) so EACH artwork
   FILE reaches its own Shopify line item, then opens the cart.
   ===================================================================== */
(function () {
'use strict';

var DEFAULT_COLOR = 'Tan';

/* The four LIVE deck-mat carpet colors (verified 2026-09-29). window.DECK_COLORS
   is injected by the section with the Shopify-CDN swatch WebP url for each.
   vc = the real Shopify variant option value the color is fulfilled on
   (Mariner Blue is the Navy carpet; Soft Gray is produced on Charcoal Gray) —
   exactly the map BMOS's server-side pricing rules use. Price is identical
   across colors within a size, so vc only decides which real variant carries
   the line, never what it costs. */
function deckColors() {
  return (window.DECK_COLORS && window.DECK_COLORS.length) ? window.DECK_COLORS : [
    { c: 'Tan',           h: '#C8A870', vc: 'Tan' },
    { c: 'Mariner Blue',  h: '#0D2148', vc: 'Navy' },
    { c: 'Soft Gray',     h: '#A0A0A0', vc: 'Charcoal Gray' },
    { c: 'Charcoal Gray', h: '#505050', vc: 'Charcoal Gray' }
  ];
}

/* Four standard embroidered deck-mat sizes — verified live prices + variant ids
   (custom-embroidered-boat-mat). Each size lists the real Shopify variant id per
   fulfillment color. Larger/other sizes go through the Custom Size Quote. */
var SIZES = [
  { key: '36x24', w: 36, h: 24, label: '36" × 24"', price: 299.95, popular: true,
    variants: { 'Tan': 50099471646999, 'Navy': 50099471679767, 'Charcoal Gray': 50099471712535 } },
  { key: '48x36', w: 48, h: 36, label: '48" × 36"', price: 599.95,
    variants: { 'Tan': 50099471745303, 'Navy': 50099471778071, 'Charcoal Gray': 50099471810839 } },
  { key: '60x30', w: 60, h: 30, label: '60" × 30"', price: 699.95,
    variants: { 'Tan': 50099471843607, 'Navy': 50099471876375, 'Charcoal Gray': 50099471909143 } },
  { key: '72x36', w: 72, h: 36, label: '72" × 36"', price: 849.95,
    variants: { 'Tan': 50099471941911, 'Navy': 50099471974679, 'Charcoal Gray': 50099472007447 } }
];
function variantFor(size, color) {
  var vc = (color && color.vc) || 'Tan';
  return size.variants[vc] || size.variants['Tan'];
}

/* Curated mat-text fonts (Patrick 2026-09-22): a small set — clean block styles,
   two scripts, and Hobo (rendered with Kavoon, the licensed Google-Fonts cut of
   the classic Hobo style; the order records the customer's chosen font name and
   production sets the final face at proof time as always). Loaded via Google
   Fonts in the section; document.fonts.load() before drawing so the canvas
   never paints a fallback face. */
/* Exactly five customer-facing styles (Patrick 2026-09-22) — simple names only,
   no technical font-family names shown, and every face has substantial stroke
   weight (prints cleanly; works for embroidery-class lettering too). Thin
   scripts (Great Vibes) and the lighter blocks (Oswald/Montserrat) removed.
   Faces underneath: Bold Block=Archivo Black (unchanged), Serif Block=Noto
   Serif 900, Brush Script=Pacifico, Bold Script=Dancing Script 700,
   Hobo=Kavoon (licensed Hobo-style cut, as before). */
var FONTS = [
  { key: 'boldblock',   label: 'Bold Block',   css: "'Archivo Black', sans-serif",   weight: '400' },
  { key: 'serifblock',  label: 'Serif Block',  css: "'Noto Serif', 'Times New Roman', serif", weight: '900' },
  { key: 'brushscript', label: 'Brush Script', css: "'Pacifico', cursive",           weight: '400' },
  { key: 'boldscript',  label: 'Bold Script',  css: "'Dancing Script', cursive",     weight: '700' }
];

var DIGITIZING_FEE = { variant: 50100757659927, price: 150 };  /* $150 one-time new-logo digitizing (Patrick 2026-10-09: now on deck too) */
function curDigiFee() { return (S.logo && S.digitizing) ? DIGITIZING_FEE.price : 0; }
var S = {
  customMode: false,
  size: SIZES[0],
  color: null,
  /* Step 3 is LOGO OR TEXT, never both (Patrick 2026-09-22) — a simple general
     representation, not a design program. mode drives which controls show and
     switching modes clears the other option's content from the preview. */
  mode: 'logo',
  logo: null, logoFile: null, logoName: '',
  digitizing: false, logoOnFile: false,
  txt: { value: '', font: FONTS[0], scale: 0.5, dx: 0, dy: 0 },
  qty: 1,
  saved: [],                       /* banked configurations */
  art: { scale: 0.6, dx: 0, dy: 0 }
};
function hasText() { return S.txt.value.trim() !== ''; }
function hasDesign() { return !!S.logo || hasText(); }

function el(id) { return document.getElementById(id); }
function money(n) { return '$' + n.toFixed(2); }

/* =============== STEP 1 — SIZES =============== */
function buildSizes() {
  var host = el('hdSizes'); if (!host) return;
  host.innerHTML = '';
  SIZES.forEach(function (z) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'szcard' + (!S.customMode && S.size.key === z.key ? ' on' : '');
    b.innerHTML = (z.popular ? '<span class="pop">MOST POPULAR</span>' : '')
      + '<span class="sz">' + z.label + '</span><span class="pr">' + money(z.price) + '</span>';
    b.onclick = function () { S.customMode = false; S.size = z; buildSizes(); syncTotals(); draw(); };
    host.appendChild(b);
  });
  /* CUSTOM SIZE is now a dedicated "Need a Custom Size?" block below the grid
     (opens the same quote modal via hdymCsqOpen) — no in-grid card. */
}

/* =============== PRICE / QTY / TOTALS =============== */
function savedTotal() { var sum=0, seen={}; S.saved.forEach(function(m){ sum += m.price*m.qty; if(m.digitizing && m.logoName && !seen[m.logoName]){ seen[m.logoName]=true; sum+=DIGITIZING_FEE.price; } }); return sum; }
function syncTotals() {
  var p = el('hdPrice'), btn = el('hdAddCart'), sl = el('hdSizeLabel'), q = el('hdQty'),
      sc = el('hdSumColor'), tot = el('hdTotal');
  if (q) q.textContent = String(S.qty);
  if (sc) sc.textContent = S.color ? S.color.c : DEFAULT_COLOR;
  var total = savedTotal();
  if (false) { /* custom sizes now go through the quote modal */ } else {
    if (p) p.textContent = money(S.size.price) + (S.qty > 1 ? '  × ' + S.qty : '');
    if (sl) sl.textContent = S.size.label;
    var dg = curDigiFee();
    if (btn) btn.textContent = 'ADD TO CART — ' + money(total + S.size.price * S.qty + dg);
    total += S.size.price * S.qty + dg;
    var rd = el('hdFeeDigi'); if (rd) rd.hidden = dg === 0;
  }
  if (tot) tot.textContent = money(total);
  renderSaved();
}
window.hdymQty = function (d) { S.qty = Math.min(10, Math.max(1, S.qty + d)); syncTotals(); };

/* =============== STEP 2 — COLORS (four embroidered carpet colors) =============== */
function buildColors() {
  var host = el('hdColors'); if (!host) return;
  host.innerHTML = '';
  deckColors().forEach(function (c) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'sw' + (S.color && S.color.c === c.c ? ' on' : '');
    b.title = c.c; b.setAttribute('aria-label', 'Carpet color ' + c.c);
    b.style.backgroundColor = c.h;
    if (c.sw) { b.style.backgroundImage = 'url(' + c.sw + ')'; b.style.backgroundSize = 'cover'; b.style.backgroundPosition = 'center'; }
    b.innerHTML = '<span class="swname">' + c.c + '</span>';
    b.onclick = function () { setColor(c); };
    b.dataset.cell = c.c;
    host.appendChild(b);
  });
}
/* Carpet texture per color: the swatch WebP is a real carpet-texture tile, so we
   reuse it as the mat surface pattern. Falls back to the solid hex if it can't load. */
var tileCache = {};
function tileImg(c, cb) {
  var key = c && c.c ? c.c : 'x';
  if (tileCache[key]) { cb(tileCache[key]); return; }
  if (!c || !c.sw) { cb(null); return; }
  var im = new Image();
  im.crossOrigin = 'anonymous';
  im.onload = function () { tileCache[key] = im; cb(im); };
  im.onerror = function () { cb(null); };
  im.src = c.sw;
}
function setColor(c) {
  S.color = c;
  var host = el('hdColors');
  if (host) [].forEach.call(host.children, function (b) { b.classList.toggle('on', b.dataset.cell === c.c); });
  var nm = el('hdColorName'); if (nm) nm.textContent = c.c;
  syncTotals();
  tileImg(c, function () { draw(); });
}

/* =============== STEP 3 — LOGO =============== */
function wireUpload() {
  var inp = el('hdLogoFile'); if (!inp) return;
  inp.addEventListener('change', function () {
    var f = inp.files && inp.files[0]; if (!f) return;
    var url = URL.createObjectURL(f);
    var im = new Image();
    im.onload = function () {
      S.logo = im; S.logoFile = f; S.logoName = f.name;
      S.art = { scale: 0.6, dx: 0, dy: 0 };
      /* Pre-encode for the gallery round-trip snapshot: FileReader is async, so
         doing this at CLICK time loses the race against navigation — encode once
         here instead, long before any gallery click. */
      S.logoDataUrl = null;
      if (f.size <= 2.5 * 1024 * 1024) {
        try {
          var fr2 = new FileReader();
          fr2.onload = function () { S.logoDataUrl = fr2.result; };
          fr2.readAsDataURL(f);
        } catch (e2) { /* snapshot just won't carry the logo */ }
      }
      var th = el('hdUpTh'); if (th) { th.src = url; th.style.display = 'block'; }
      var tx = el('hdUpTxt'); if (tx) tx.textContent = f.name + ' — uploaded. Your mat preview is below.';
      var ctr = el('hdArtCtrls'); if (ctr) ctr.hidden = false;
      updateDigStatus(); digOpen();
      draw();
      var pv = el('hdPreviewWrap'); if (pv && pv.scrollIntoView) pv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    im.onerror = function () {
      var tx = el('hdUpTxt'); if (tx) tx.textContent = 'That file could not be read as an image — please try a PNG, JPG, SVG or WEBP.';
    };
    im.src = url;
  });
}
function clearLogo() {
  S.logo = null; S.logoFile = null; S.logoName = '';
  S.digitizing = false; S.logoOnFile = false;
  var inp = el('hdLogoFile'); if (inp) inp.value = '';
  if(typeof updateDigStatus==='function') updateDigStatus();
  S.logoDataUrl = null;
  var th = el('hdUpTh'); if (th) { th.removeAttribute('src'); th.style.display = 'none'; }
  var tx = el('hdUpTxt'); if (tx) tx.textContent = 'UPLOAD YOUR YACHT LOGO HERE';
  var ctr = el('hdArtCtrls'); if (ctr) ctr.hidden = true;
}
function nudge(dxPct, dyPct) { S.art.dx += dxPct; S.art.dy += dyPct; draw(); }
function scaleArt(f) { S.art.scale = Math.min(0.96, Math.max(0.1, S.art.scale * f)); draw(); }
function resetArt() { S.art = { scale: 0.6, dx: 0, dy: 0 }; draw(); }

/* =============== STEP 3 — ADD TEXT =============== */
function loadTxtFont(cb) {
  var f = S.txt.font;
  if (document.fonts && document.fonts.load) {
    document.fonts.load(f.weight + ' 60px ' + f.css).then(function () { cb(); }).catch(function () { cb(); });
  } else cb();
}
function wireText() {
  var inp = el('hdTextInput'), sel = el('hdTextFont');
  if (sel) {
    FONTS.forEach(function (f) {
      var o = document.createElement('option');
      o.value = f.key; o.textContent = f.label;
      sel.appendChild(o);
    });
    sel.onchange = function () {
      S.txt.font = FONTS.filter(function (f) { return f.key === sel.value; })[0] || FONTS[0];
      S.txt.dx = 0; S.txt.dy = 0;             /* recenter on font change */
      loadTxtFont(draw);
    };
  }
  if (inp) {
    inp.addEventListener('input', function () {
      S.txt.value = inp.value;
      S.txt.dx = 0; S.txt.dy = 0;             /* recenter on every wording change */
      var c = el('hdTxtCtrls'); if (c) c.hidden = S.mode !== 'text' || !hasText();
      loadTxtFont(draw);
    });
  }
}
function clearText() {
  S.txt = { value: '', font: FONTS[0], scale: 0.5, dx: 0, dy: 0 };
  var inp = el('hdTextInput'); if (inp) inp.value = '';
  var sel = el('hdTextFont'); if (sel) sel.value = FONTS[0].key;
  var c = el('hdTxtCtrls'); if (c) c.hidden = true;
}
/* Text is ALWAYS true-center (Patrick 2026-09-22) — no positioning controls,
   only a size adjustment. dx/dy stay 0; draw() centers and clamps. */
function txtScale(f) { S.txt.scale = Math.min(1.4, Math.max(0.16, S.txt.scale * f)); S.txt.dx = 0; S.txt.dy = 0; draw(); }
function updateModeUI() {
  var isLogo = S.mode === 'logo';
  var bL = el('hdModeLogo'), bT = el('hdModeText');
  if (bL) { bL.classList.toggle('on', isLogo); bL.setAttribute('aria-pressed', isLogo ? 'true' : 'false'); }
  if (bT) { bT.classList.toggle('on', !isLogo); bT.setAttribute('aria-pressed', !isLogo ? 'true' : 'false'); }
  var up = el('hdUpWrap'); if (up) up.hidden = !isLogo;
  var ac = el('hdArtCtrls'); if (ac) ac.hidden = !isLogo || !S.logo;
  var tb = el('hdTxtBox'); if (tb) tb.hidden = isLogo;
  var tc = el('hdTxtCtrls'); if (tc) tc.hidden = isLogo || !hasText();
}
window.hdymMode = function (m) {
  if (m !== 'logo' && m !== 'text') return;
  if (S.mode === m) { updateModeUI(); return; }
  S.mode = m;
  if (m === 'logo') clearText(); else clearLogo();
  updateModeUI(); syncTotals(); draw();
};

/* =============== THE PREVIEW =============== */
var CVW = 1200;
function matGeom() {
  var aspect = S.size.h / S.size.w;
  var W = CVW, H = Math.round(CVW * aspect);
  var bind = Math.round(Math.min(W, H) * 0.05);    /* the serged/bound edge band of the carpet mat */
  var frame = Math.round(Math.min(W, H) * 0.012);  /* thin bound trim edge (not a hard gripper) */
  return { W: W, H: H, bind: bind, frame: frame };
}
function draw(cb) {
  var cv = el('hdCv'); if (!cv) { if (cb) cb(); return; }
  var g = matGeom();
  var pad = 70, lip = Math.round(g.H * 0.035);
  cv.width = g.W + pad * 2; cv.height = g.H + pad * 2 + lip;
  var x = pad, y = pad;
  var ctx = cv.getContext('2d');
  ctx.clearRect(0, 0, cv.width, cv.height);

  ctx.save();
  ctx.filter = 'blur(26px)';
  ctx.fillStyle = 'rgba(0,0,0,.5)';
  ctx.fillRect(x + 12, y + g.H - 8 + lip, g.W - 24, 26);
  ctx.restore();

  /* Bound-edge trim — a thin darker border framing the carpet mat (embroidered
     deck mats are serged/bound, not gripper-backed). Tone follows the carpet. */
  var col0 = S.color || { c: DEFAULT_COLOR, h: '#C8A870' };
  ctx.fillStyle = 'rgba(20,24,30,.85)';
  roundRect(ctx, x - g.frame, y - g.frame, g.W + g.frame * 2, g.H + g.frame * 2 + lip, 14); ctx.fill();

  var fallback = col0.h;
  tileImg(col0, function (tile) {
    ctx.save();
    roundRect(ctx, x, y, g.W, g.H, 10); ctx.clip();
    if (tile) ctx.fillStyle = ctx.createPattern(tile, 'repeat');
    else ctx.fillStyle = fallback;
    ctx.fillRect(x, y, g.W, g.H);
    var sheen = ctx.createLinearGradient(x, y, x, y + g.H);
    sheen.addColorStop(0, 'rgba(255,255,255,.10)');
    sheen.addColorStop(0.25, 'rgba(255,255,255,0)');
    sheen.addColorStop(1, 'rgba(0,0,0,.14)');
    ctx.fillStyle = sheen; ctx.fillRect(x, y, g.W, g.H);
    ctx.restore();

    /* bound edge band (same color family, reads as stitched trim inside the black frame) */
    ctx.save();
    roundRect(ctx, x, y, g.W, g.H, 10); ctx.clip();
    ctx.save();
    roundRect(ctx, x, y, g.W, g.H, 10);
    roundRect(ctx, x + g.bind, y + g.bind, g.W - g.bind * 2, g.H - g.bind * 2, 6);
    ctx.clip('evenodd');
    if (tile) { ctx.fillStyle = ctx.createPattern(tile, 'repeat'); ctx.fillRect(x, y, g.W, g.H); }
    ctx.fillStyle = 'rgba(0,0,0,.20)'; ctx.fillRect(x, y, g.W, g.H);
    ctx.restore();
    ctx.strokeStyle = 'rgba(0,0,0,.4)'; ctx.lineWidth = 2;
    roundRect(ctx, x + g.bind, y + g.bind, g.W - g.bind * 2, g.H - g.bind * 2, 6); ctx.stroke();
    ctx.restore();

    var innerX = x + g.bind * 1.6, innerY = y + g.bind * 1.6;
    var innerW = g.W - g.bind * 3.2, innerH = g.H - g.bind * 3.2;
    if (S.logo) {
      var ar = S.logo.naturalHeight / S.logo.naturalWidth;
      var aw = innerW * S.art.scale, ah = aw * ar;
      if (ah > innerH * 0.96) { ah = innerH * 0.96; aw = ah / ar; }
      var cx = innerX + innerW / 2 + S.art.dx * innerW;
      var cy = innerY + innerH / 2 + S.art.dy * innerH;
      cx = Math.max(innerX + aw / 2, Math.min(innerX + innerW - aw / 2, cx));
      cy = Math.max(innerY + ah / 2, Math.min(innerY + innerH - ah / 2, cy));
      S.art.dx = (cx - innerX - innerW / 2) / innerW;
      S.art.dy = (cy - innerY - innerH / 2) / innerH;
      ctx.save();
      roundRect(ctx, innerX, innerY, innerW, innerH, 4); ctx.clip();
      ctx.shadowColor = 'rgba(0,0,0,.18)'; ctx.shadowBlur = 6; ctx.shadowOffsetY = 2;
      ctx.drawImage(S.logo, cx - aw / 2, cy - ah / 2, aw, ah);
      ctx.restore();
    }
    if (hasText()) {
      /* Printed mat text — sized from the mat, clamped inside the binding, and
         auto black/white for contrast against the selected carpet color. Logo
         and text are fully independent: either or both. */
      var tstr = S.txt.value.trim();
      var fsize = innerH * 0.42 * S.txt.scale;
      ctx.save();
      roundRect(ctx, innerX, innerY, innerW, innerH, 4); ctx.clip();
      ctx.font = S.txt.font.weight + ' ' + Math.round(fsize) + 'px ' + S.txt.font.css;
      var tw = ctx.measureText(tstr).width;
      if (tw > innerW * 0.94) { fsize = fsize * (innerW * 0.94) / tw; ctx.font = S.txt.font.weight + ' ' + Math.round(fsize) + 'px ' + S.txt.font.css; tw = ctx.measureText(tstr).width; }
      var hex = (S.color ? S.color.h : '#DCE0E5').replace('#', '');
      var lum = (parseInt(hex.substr(0, 2), 16) * 0.299 + parseInt(hex.substr(2, 2), 16) * 0.587 + parseInt(hex.substr(4, 2), 16) * 0.114) / 255;
      /* true center of the mat, clamped inside the binding */
      var tx2 = innerX + innerW / 2;
      var ty2 = innerY + innerH / 2;
      tx2 = Math.max(innerX + tw / 2, Math.min(innerX + innerW - tw / 2, tx2));
      ty2 = Math.max(innerY + fsize / 2, Math.min(innerY + innerH - fsize / 2, ty2));
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.shadowColor = 'rgba(0,0,0,.22)'; ctx.shadowBlur = 5; ctx.shadowOffsetY = 2;
      ctx.fillStyle = lum > 0.55 ? '#101820' : '#FFFFFF';
      ctx.fillText(tstr, tx2, ty2);
      ctx.restore();
    }
    if (!S.logo && !hasText()) {
      var hx0 = (col0.h || '#C8A870').replace('#','');
      var lm0 = (parseInt(hx0.substr(0,2),16)*0.299 + parseInt(hx0.substr(2,2),16)*0.587 + parseInt(hx0.substr(4,2),16)*0.114)/255;
      ctx.save();
      ctx.fillStyle = lm0 > 0.55 ? 'rgba(20,30,45,.45)' : 'rgba(255,255,255,.5)';
      ctx.font = '600 ' + Math.round(g.H * 0.07) + 'px Barlow, sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('YOUR YACHT LOGO OR TEXT HERE', x + g.W / 2, y + g.H / 2);
      ctx.restore();
    }
    var cap = el('hdCvCap');
    if (cap) cap.textContent = 'Custom Embroidered Deck Mat — ' + S.size.label +
      ' · ' + col0.c + ' · AquaLoc® marine backing';
    if (cb) cb(cv);
  });
}
function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function wireDrag() {
  var cv = el('hdCv'); if (!cv) return;
  var dragging = false, last = null;
  function pos(e) {
    var r = cv.getBoundingClientRect();
    var sx = cv.width / r.width, sy = cv.height / r.height;
    var t = e.touches ? e.touches[0] : e;
    return { x: (t.clientX - r.left) * sx, y: (t.clientY - r.top) * sy };
  }
  function down(e) { /* logo dragging on the mat disabled (Patrick 2026-09-29) — use the Adjust Your Logo buttons under Step 4 */ }
  function move(e) {
    if (!dragging || !last) return;
    var p = pos(e), g = matGeom();
    S.art.dx += (p.x - last.x) / (g.W - g.bind * 3.2);
    S.art.dy += (p.y - last.y) / (g.H - g.bind * 3.2);
    last = p; draw(); e.preventDefault();
  }
  function up() { dragging = false; last = null; }
  cv.addEventListener('pointerdown', down);
  window.addEventListener('pointermove', move, { passive: false });
  window.addEventListener('pointerup', up);
  cv.addEventListener('touchstart', down, { passive: false });
  window.addEventListener('touchmove', move, { passive: false });
  window.addEventListener('touchend', up);
}

/* =============== SAVED CONFIGURATIONS =============== */
function currentThumb() {
  try { var cv = el('hdCv'); return cv ? cv.toDataURL('image/jpeg', 0.5) : null; } catch (e) { return null; }
}
/* Full-quality preview capture for the order proof (Patrick 2026-09-21): the
   exact pixels the customer sees, downscaled to <=1200px wide to keep the
   upload small. Uploaded to BMOS at Add-to-Cart; the returned permanent URL
   rides the line item so the cart AND the order proof PDF can show the real
   configured mat. A failed upload never blocks the sale. */
var DP_ENDPOINT = 'https://admin.boatmat.com/public/web-intake/design-proof/preview';
function capturePreview() {
  try {
    var cv = el('hdCv'); if (!cv || !cv.width) return null;
    var MAXW = 1200;
    if (cv.width <= MAXW) return cv.toDataURL('image/png');
    var s2 = MAXW / cv.width;
    var c2 = document.createElement('canvas');
    c2.width = MAXW; c2.height = Math.round(cv.height * s2);
    c2.getContext('2d').drawImage(cv, 0, 0, c2.width, c2.height);
    return c2.toDataURL('image/png');
  } catch (e) { return null; }
}
function uploadPreview(cfg, cb) {
  if (!cfg.preview || !window.fetch) { cb(); return; }
  var ctrl = ('AbortController' in window) ? new AbortController() : null;
  var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
  fetch(DP_ENDPOINT, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ png: cfg.preview, station: 'embroidered-deck',
      config: { size: cfg.label, sizeFt: cfg.sizeFt, color: cfg.colorC, qty: cfg.qty, placement: cfg.placement, file: cfg.logoName, text: cfg.text || '', textPlacement: cfg.textPlacement || null } }),
    signal: ctrl ? ctrl.signal : undefined
  }).then(function (r) { return r.json(); })
    .then(function (j) { clearTimeout(t); if (j && j.ok) { cfg.previewId = j.id; cfg.previewUrl = j.url; } cb(); })
    .catch(function () { clearTimeout(t); cb(); });
}
function renderSaved() {
  var host = el('hdSavedMats'); if (!host) return;
  host.hidden = S.saved.length === 0;
  host.innerHTML = '';
  S.saved.forEach(function (m, i) {
    var d = document.createElement('div');
    d.className = 'savedmat';
    d.innerHTML =
      (m.thumb ? '<img class="th" src="' + m.thumb + '" alt="">' : '<span class="th" style="background:' + m.hex + ';display:inline-block"></span>')
      + '<span class="meta"><b>Mat ' + (i + 1) + ' — ' + m.label + ' · Color ' + m.colorC + ' · Qty ' + m.qty + '</b>'
      + '<span class="d">' + (m.logoName || (m.text ? '“' + m.text + '”' : 'artwork attached')) + (m.notes ? ' · note added' : '') + '</span></span>'
      + '<span class="pr">' + money(m.price * m.qty) + '</span>'
      + '<button type="button" class="rm" data-i="' + i + '">Remove</button>';
    d.querySelector('.rm').onclick = function () { S.saved.splice(i, 1); syncTotals(); };
    host.appendChild(d);
  });
}
window.hdymAddAdditional = function () {
  var msg = el('hdCartMsg');
  if (!hasDesign()) {
    if (msg) { msg.hidden = false; msg.innerHTML = '<b>Upload this mat’s logo or add text first</b> (Step 3), then ADD ADDITIONAL MAT banks it and starts your next mat.'; }
    return;
  }
  if (msg) msg.hidden = true;
  var color = S.color || { c: DEFAULT_COLOR, h: '#C8A870', vc: 'Tan' };
  S.saved.push({
    label: S.size.label, sizeKey: S.size.key, sizeFt: S.size.w + ' x ' + S.size.h,
    variant: variantFor(S.size, color), price: S.size.price,
    colorC: color.c, hex: color.h, qty: S.qty,
    digitizing: (!!S.logo && S.digitizing), logoOnFile: (!!S.logo && S.logoOnFile),
    file: S.logoFile, logoName: S.logoName,
    placement: { scale: +S.art.scale.toFixed(4), dx: +S.art.dx.toFixed(4), dy: +S.art.dy.toFixed(4) },
    text: S.txt.value.trim(), textFont: S.txt.font.label,
    textPlacement: hasText() ? { font: S.txt.font.key, scale: +S.txt.scale.toFixed(4), dx: +S.txt.dx.toFixed(4), dy: +S.txt.dy.toFixed(4) } : null,
    notes: (el('hdNotes') && el('hdNotes').value || '').trim(),
    thumb: currentThumb(),
    preview: capturePreview()
  });
  /* fresh canvas for the next mat */
  clearLogo();
  clearText();
  S.mode = 'logo'; updateModeUI();
  S.qty = 1;
  if (el('hdNotes')) el('hdNotes').value = '';
  syncTotals(); draw();
  var s1 = el('hdStep1'); if (s1 && s1.scrollIntoView) s1.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

/* =============== ADD TO CART (multi-config, real multipart posts) =============== */
function designId() {
  var d = new Date();
  var p = function (n) { return (n < 10 ? '0' : '') + n; };
  return 'EDM-' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '-' +
    p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds()) + '-' +
    Math.random().toString(36).slice(2, 6).toUpperCase();
}
function cartFrame() {
  var f = el('hdymCartFrame');
  if (!f) {
    f = document.createElement('iframe');
    f.id = 'hdymCartFrame'; f.name = 'hdymCartFrame'; f.style.display = 'none';
    document.body.appendChild(f);
  }
  return f;
}
/* ===== ONE-TIME LOGO DIGITIZING pop-up (shown at upload) ===== */
function digOpen(){ var m=el('digPop'); if(!m) return; var cur=S.digitizing?'new':(S.logoOnFile?'file':''); var rs=m.querySelectorAll('input[name=digChoice]'); for(var i=0;i<rs.length;i++) rs[i].checked=(rs[i].value===cur); var e=el('digErr'); if(e) e.hidden=true; m.hidden=false; }
window.digOpen=digOpen;
window.digClose=function(){ var m=el('digPop'); if(m) m.hidden=true; updateDigStatus(); syncTotals(); };
window.digConfirm=function(){ var m=el('digPop'); var sel=m&&m.querySelector('input[name=digChoice]:checked'); if(!sel){ var e=el('digErr'); if(e) e.hidden=false; return; } if(sel.value==='new'){ S.digitizing=true; S.logoOnFile=false; } else { S.logoOnFile=true; S.digitizing=false; } if(m) m.hidden=true; updateDigStatus(); syncTotals(); };
function updateDigStatus(){ var row=el('hdDigStatus'), tx=el('hdDigStatusTxt'); if(!row) return; if(!(S.logo && S.mode!=='text')){ row.hidden=true; return; } row.hidden=false; if(S.digitizing) tx.innerHTML='<b>Logo digitizing: $150.00</b> one-time fee — added to your order.'; else if(S.logoOnFile) tx.innerHTML='<b>Logo digitizing: $0.00</b> — you confirmed this exact logo was digitized by BoatMat before.'; else tx.innerHTML='<b>Logo digitizing: not yet confirmed.</b> Our office will review before production.'; }
function submitConfig(cfg, done) {
  var form = document.createElement('form');
  form.method = 'post'; form.action = '/cart/add'; form.enctype = 'multipart/form-data';
  form.target = 'hdymCartFrame'; form.style.display = 'none';
  function hidden(name, value) {
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = name; i.value = value;
    form.appendChild(i);
  }
  if (cfg.fee) {
    hidden('id', String(cfg.variant));
    hidden('quantity', '1');
    hidden('properties[Fee]', 'One-Time Embroidery Logo Digitizing — $150.00');
    hidden('properties[For Logo]', cfg.forLogo || 'uploaded logo');
    var frameF = cartFrame(); var settledF = false;
    function finishF(){ if(settledF) return; settledF=true; form.remove(); done(); }
    frameF.addEventListener('load', finishF, { once: true }); setTimeout(finishF, 6000);
    document.body.appendChild(form); form.submit(); return;
  }
  hidden('id', String(cfg.variant));
  hidden('quantity', String(cfg.qty));
  hidden('properties[Product]', 'Custom Embroidered Deck Mat');
  hidden('properties[Size]', cfg.label);
  hidden('properties[Mat Color]', cfg.colorC);
  hidden('properties[Backing]', 'AquaLoc® marine backing');
  hidden('properties[Embroidery]', 'Custom Precision Embroidery');
  if (cfg.sizeKey === '36x24' || cfg.label === '36" × 24"') hidden('properties[Included]', 'One line of embroidery');
  if (cfg.text) { hidden('properties[Mat Text]', cfg.text); hidden('properties[Text Font]', cfg.textFont); }
  /* Deck-mat logo digitizing is INCLUDED at no charge and kept on file for future
     orders — the boarding product is what carries the $150 fee, not this one. No
     digitizing line item is added here (verified against live config 2026-09-29). */
  if (cfg.logoName) {
    if (cfg.digitizing) {
      hidden('properties[Embroidery Logo Digitizing]', '$150.00 one-time digitizing fee — AUTHORIZED by the customer and added to this order (separate line).');
      hidden('properties[_bm_digitizing_review]', 'NEW LOGO — customer authorized the $150 digitizing fee. Proceed to digitize.');
    } else if (cfg.logoOnFile) {
      hidden('properties[Embroidery Logo Digitizing]', 'Previously digitized — customer confirms the EXACT same logo was digitized by BoatMat on an earlier order (no new fee).');
      hidden('properties[_bm_digitizing_review]', 'PREVIOUSLY DIGITIZED — VERIFY the exact logo is on file; if not found, contact the customer and invoice the $150 before production.');
    } else {
      hidden('properties[Embroidery Logo Digitizing]', 'NOT CONFIRMED — Office Review Required.');
      hidden('properties[_bm_digitizing_review]', 'DIGITIZING NOT CONFIRMED — customer dismissed the notice. Review before production; invoice $150 if new digitizing is needed. Do NOT auto-charge.');
    }
  }
  if (cfg.notes) hidden('properties[Special Notes]', cfg.notes);
  hidden('properties[_design_id]', designId());
  hidden('properties[_mat_color]', cfg.colorC);
  hidden('properties[_mat_size_in]', cfg.sizeFt);
  hidden('properties[_artwork_placement]', JSON.stringify(Object.assign({}, cfg.placement, { file: cfg.logoName })));
  if (cfg.textPlacement) hidden('properties[_text_placement]', JSON.stringify(Object.assign({ text: cfg.text }, cfg.textPlacement)));
  hidden('properties[_designed_at]', new Date().toISOString());
  hidden('properties[_design_station]', 'embroidered-deck');
  if (cfg.previewId) hidden('properties[_preview_id]', cfg.previewId);
  if (cfg.previewUrl) hidden('properties[_preview_url]', cfg.previewUrl);
  hidden('properties[_proof_status]', 'AWAITING PROOF APPROVAL');
  if (cfg.file && window.DataTransfer) {
    try {
      var fi = document.createElement('input');
      fi.type = 'file'; fi.name = 'properties[■ Artwork File]';
      var dt = new DataTransfer();
      dt.items.add(cfg.file);
      fi.files = dt.files;
      form.appendChild(fi);
    } catch (e) { /* very old browser: config still carts, file noted in placement */ }
  }
  var frame = cartFrame();
  var settled = false;
  function finish() { if (settled) return; settled = true; form.remove(); done(); }
  frame.addEventListener('load', finish, { once: true });
  setTimeout(finish, 6000);
  document.body.appendChild(form);
  form.submit();
}
window.hdymAddToCart = function () {
  var msg = el('hdCartMsg');
  var queue = S.saved.slice();
  if (hasDesign()) {
    var color = S.color || { c: DEFAULT_COLOR, h: '#C8A870', vc: 'Tan' };
    queue.push({
      label: S.size.label, sizeKey: S.size.key, sizeFt: S.size.w + ' x ' + S.size.h, variant: variantFor(S.size, color),
      price: S.size.price, colorC: color.c, qty: S.qty, file: S.logoFile, logoName: S.logoName,
      digitizing: (!!S.logo && S.digitizing), logoOnFile: (!!S.logo && S.logoOnFile),
      placement: { scale: +S.art.scale.toFixed(4), dx: +S.art.dx.toFixed(4), dy: +S.art.dy.toFixed(4) },
      text: S.txt.value.trim(), textFont: S.txt.font.label,
      textPlacement: hasText() ? { font: S.txt.font.key, scale: +S.txt.scale.toFixed(4), dx: +S.txt.dx.toFixed(4), dy: +S.txt.dy.toFixed(4) } : null,
      notes: (el('hdNotes') && el('hdNotes').value || '').trim(),
      preview: capturePreview()
    });
  }
  if (!queue.length) {
    if (msg) { msg.hidden = false; msg.innerHTML = '<b>Please upload your yacht logo or add your mat text first</b> — Step 3 above. Questions? Call 321.751.4636.'; }
    var st = el('hdStep3'); if (st && st.scrollIntoView) st.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }
  if (msg) msg.hidden = true;
  var mats = queue, _digLogos = {}; queue = [];
  mats.forEach(function (m) { queue.push(m); if (m.digitizing && m.logoName && !_digLogos[m.logoName]) { _digLogos[m.logoName] = true; queue.push({ fee: true, variant: DIGITIZING_FEE.variant, qty: 1, forLogo: m.logoName }); } });
  var btn = el('hdAddCart');
  if (btn) { btn.disabled = true; btn.textContent = 'Adding to cart…'; }
  var i = 0;
  (function next() {
    if (i >= queue.length) { window.location.href = '/cart'; return; }
    var cfg = queue[i++];
    if (cfg.fee) { submitConfig(cfg, next); return; }
    if (btn && mats.length > 1) btn.textContent = 'Adding mat…';
    uploadPreview(cfg, function () { submitConfig(cfg, next); });
  })();
};

/* =============== CUSTOM SIZE QUOTE MODAL =============== */
var CSQ_ENDPOINT = 'https://admin.boatmat.com/public/web-intake/custom-size-quote';
function csqRow(vals) {
  var host = el('csqRows'); if (!host) return;
  var d = document.createElement('div');
  d.className = 'csq-row';
  d.innerHTML = '<input type="text" maxlength="30" placeholder="Width (e.g. 9\')" class="w">'
    + '<input type="text" maxlength="30" placeholder="Length (e.g. 4\')" class="l">'
    + '<input type="number" min="1" max="999" value="' + ((vals && vals.qty) || 1) + '" class="q" aria-label="Quantity">'
    + '<button type="button" class="rm" aria-label="Remove size">&times;</button>';
  d.querySelector('.rm').onclick = function () {
    if (el('csqRows').children.length > 1) d.remove();
    else { d.querySelector('.w').value = ''; d.querySelector('.l').value = ''; d.querySelector('.q').value = 1; }
  };
  host.appendChild(d);
}
window.hdymCsqAddRow = function () { csqRow(); };
function trapModal(m, closeFn) {
  if (!m || m.__a11y) return; m.__a11y = 1;
  m.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && closeFn) { closeFn(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(m.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
}
window.hdymCsqOpen = function () {
  var m = el('hdCsq'); if (!m) return;
  el('csqForm').hidden = false; el('csqDone').hidden = true;
  var err = el('csqErr'); if (err) err.hidden = true;
  if (!el('csqRows').children.length) csqRow();
  m.hidden = false;
  document.body.style.overflow = 'hidden';
  trapModal(m, window.hdymCsqClose);
  var _cf = m.querySelector('input,button,a,select,textarea'); if (_cf) { try { _cf.focus(); } catch (e) {} }
};
window.hdymCsqClose = function () {
  var m = el('hdCsq'); if (m) m.hidden = true;
  document.body.style.overflow = '';
};
window.hdymCsqSend = function () {
  var err = el('csqErr');
  function fail(t) { if (err) { err.hidden = false; err.textContent = t; } }
  var rows = [].map.call(el('csqRows').children, function (d) {
    return { width: d.querySelector('.w').value.trim(), length: d.querySelector('.l').value.trim(), qty: d.querySelector('.q').value };
  }).filter(function (r) { return r.width && r.length; });
  var name = el('csqName').value.trim(), email = el('csqEmail').value.trim(), phone = el('csqPhone').value.trim();
  if (!rows.length) return fail('Please enter at least one size — width and length.');
  if (!name) return fail('Please enter your name.');
  if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email)) return fail('Please enter a valid email address.');
  if (!phone) return fail('Please enter your phone number.');
  if (err) err.hidden = true;
  var btn = el('csqSend');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
  /* upload any attached artwork first (optional; sequential; a failure keeps
     the form intact so the customer can remove the file or retry) */
  var qa = window.bmQuoteArt, qaq = qa && qa.csq;
  (qaq && qaq.items.length ? function (go) {
    qa.uploadAll(qaq, function (t) { if (btn) btn.textContent = t; }, function (ok, errText) {
      if (!ok) { if (btn) { btn.disabled = false; btn.textContent = 'SEND QUOTE REQUEST'; } fail(errText); return; }
      if (btn) btn.textContent = 'Sending…';
      go();
    });
  } : function (go) { go(); })(function () {
  fetch(CSQ_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: name, email: email, phone: phone,
      vessel: el('csqVessel').value.trim(),
      notes: el('csqNotes').value.trim(),
      company: el('csqCompany').value,
      sizes: rows,
      artworks: qaq ? qa.list(qaq) : [],
      pageUrl: window.location.href.split('?')[0]
    })
  }).then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
    .then(function (j) {
      if (btn) { btn.disabled = false; btn.textContent = 'SEND QUOTE REQUEST'; }
      if (j && j.ok) { el('csqForm').hidden = true; el('csqDone').hidden = false; }
      else fail((j && j.error) || 'Something went wrong — please call 321.751.4636.');
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'SEND QUOTE REQUEST'; }
      fail('Could not reach our server — please try again or call 321.751.4636.');
    });
  });
};

/* =============== BOOT =============== */
/* =============== GALLERY ROUND-TRIP STATE (Patrick 2026-09-22) ===============
   The gallery's "Return to Previous Page" button is history.back(); the gallery
   now opens in the SAME tab so back() lands here. Browsers usually restore this
   page from the back-forward cache with everything intact — but when one
   reloads instead, this sessionStorage snapshot (saved at the moment the
   customer clicks a gallery link) puts their in-progress design back: size,
   color, quantity, text + font + placement, and the uploaded logo (kept as a
   data URL when ≤2.5MB and rebuilt into a real File so Add to Cart still
   attaches it). Snapshot expires after 60 minutes. */
var GAL_STATE_KEY = 'bmHdymGalleryState';
function saveGalleryState() {
  try {
    var st = {
      at: Date.now(), mode: S.mode, sizeKey: S.size.key, color: S.color, qty: S.qty,
      art: S.art, txt: { value: S.txt.value, fontKey: S.txt.font.key, scale: S.txt.scale, dx: S.txt.dx, dy: S.txt.dy },
      logoName: S.logoName || '', logoData: null
    };
    if (S.logo && S.logoDataUrl) st.logoData = S.logoDataUrl;
    try { sessionStorage.setItem(GAL_STATE_KEY, JSON.stringify(st)); }
    catch (e) { st.logoData = null; sessionStorage.setItem(GAL_STATE_KEY, JSON.stringify(st)); }
  } catch (e) { /* storage unavailable — bfcache still covers the common case */ }
}
function wireGallerySave() {
  ['hdGalTop', 'hdGalBottom'].forEach(function (id) {
    var a = el(id); if (a) a.addEventListener('click', saveGalleryState);
  });
}
function restoreGalleryState() {
  var raw = null;
  try { raw = sessionStorage.getItem(GAL_STATE_KEY); } catch (e) { return; }
  if (!raw) return;
  var st = null;
  try { st = JSON.parse(raw); } catch (e) { return; }
  if (!st || !st.at || Date.now() - st.at > 60 * 60000) { try { sessionStorage.removeItem(GAL_STATE_KEY); } catch (e) {} return; }
  var z = SIZES.filter(function (x) { return x.key === st.sizeKey; })[0];
  if (z) { S.size = z; buildSizes(); }
  if (st.qty >= 1 && st.qty <= 10) S.qty = st.qty;
  if (st.mode === 'text' || st.mode === 'logo') { S.mode = st.mode; updateModeUI(); }
  if (st.art && typeof st.art.scale === 'number') S.art = st.art;
  if (st.txt && st.txt.value && S.mode === 'text') {
    S.txt.value = st.txt.value;
    S.txt.font = FONTS.filter(function (f) { return f.key === st.txt.fontKey; })[0] || FONTS[0];
    S.txt.scale = st.txt.scale; S.txt.dx = 0; S.txt.dy = 0;   /* always true center */
    var ti = el('hdTextInput'); if (ti) ti.value = st.txt.value;
    var sel = el('hdTextFont'); if (sel) sel.value = S.txt.font.key;
    loadTxtFont(function () {});
  }
  if (st.color && st.color.c) {
    /* applied after the color chart loads — boot's waitColors calls us back */
    S.__restoreColor = st.color;
  }
  if (st.logoData && st.logoName && S.mode === 'logo') {
    fetch(st.logoData).then(function (r) { return r.blob(); }).then(function (blob) {
      var f = new File([blob], st.logoName, { type: blob.type || 'image/png' });
      var im = new Image();
      im.onload = function () {
        S.logo = im; S.logoFile = f; S.logoName = st.logoName;
        var th = el('hdUpTh'); if (th) { th.src = st.logoData; th.style.display = 'block'; }
        var tx = el('hdUpTxt'); if (tx) tx.textContent = st.logoName + ' — uploaded. Your mat preview is below.';
        var ctr = el('hdArtCtrls'); if (ctr) ctr.hidden = false;
        syncTotals(); draw();
      };
      im.src = st.logoData;
    }).catch(function () {});
  }
  updateModeUI(); syncTotals(); draw();
}

function boot() {
  buildSizes(); wireUpload(); wireText(); wireDrag(); wireGallerySave();
  restoreGalleryState();
  buildColors();
  var cols = deckColors();
  var want = S.__restoreColor && S.__restoreColor.c ? S.__restoreColor.c : DEFAULT_COLOR;
  var def = cols.filter(function (c) { return c.c === want; })[0]
    || cols.filter(function (c) { return c.c === DEFAULT_COLOR; })[0] || cols[0];
  setColor(def);
  delete S.__restoreColor;
  syncTotals();
  window.hdymNudge = nudge; window.hdymScale = scaleArt; window.hdymReset = resetArt;
  window.hdymTxtScale = txtScale;
  updateModeUI();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
})();
